import React from 'react';

import { MuiThemeProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FlatButton from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';

import themeConfig from './../theme-config';
import ThemeDefault from '../theme-default';
import RecoveryPassForm from '../components/auth/RecoveryPassForm';

const styles = {
  title: {
    textAlign: 'center',
    fontSize: '24px',
    color: grey[50],
    paddingBottom: '20px',
  },
  logoLife: {
    height: 200,
    width: 400,
  },
  loginContainer: {
    width: 450,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  paper: {
    padding: 20,
    overflow: 'auto',
  },
  buttonsDiv: {
    textAlign: 'center',
    padding: 10,
  },
  flatButton: {
    color: grey[500],
  },

};

export default class LoginPage extends React.Component {

  componentWillMount() {

    const body = document.querySelector('body');
    body.style.background = `url('${themeConfig.bg}') no-repeat center center fixed`;
    body.style.backgroundSize = 'cover';

  }

  render() {

    return (
      <MuiThemeProvider theme={ThemeDefault}>
        <div>
          <div style={styles.loginContainer}>

            <Paper style={styles.paper}>

              <img style={styles.logoLife} src={themeConfig.logo} />
              <RecoveryPassForm {...this.props} />

            </Paper>

          </div>
        </div>
      </MuiThemeProvider>
    );

  }

};



// WEBPACK FOOTER //
// ./src/containers/RecoveryPassPage.js